module.exports = __webpack_public_path__ + "image-e84d8f22b657.png";